import { faker } from '@faker-js/faker'
import { defineFakeRoute } from 'vite-plugin-fake-server/client'

const AllList: any[] = []
for (let i = 0; i < 100; i++) {
  const status = faker.helpers.arrayElement(['success', 'failed'])
  const loginTime = faker.date.recent({ days: 30 })
  AllList.push({
    id: i + 1,
    username: faker.internet.username(),
    ip: faker.internet.ip(),
    userAgent: faker.internet.userAgent(),
    status,
    loginTime: loginTime.toISOString(),
    logoutTime: status === 'success' ? new Date(loginTime.getTime() + faker.number.int({ min: 1800000, max: 7200000 })).toISOString() : null,
    deviceInfo: faker.helpers.arrayElement(['Desktop', 'Mobile', 'Tablet']),
    browserInfo: faker.helpers.arrayElement(['Chrome', 'Firefox', 'Safari', 'Edge']),
    osInfo: faker.helpers.arrayElement(['Windows 10', 'macOS', 'Linux', 'iOS', 'Android']),
    location: faker.location.city() + ', ' + faker.location.country(),
  })
}

export default defineFakeRoute([
  {
    url: '/mock/record/tenant_login_log/list',
    method: 'get',
    response: ({ query }) => {
      const { username, ip, status, startTime, endTime, from, limit } = query
      const list = AllList.filter((item) => {
        const matchUsername = username ? item.username.toLowerCase().includes(username.toLowerCase()) : true
        const matchIp = ip ? item.ip.includes(ip) : true
        const matchStatus = status ? item.status === status : true
        const matchStartTime = startTime ? new Date(item.loginTime) >= new Date(startTime) : true
        const matchEndTime = endTime ? new Date(item.loginTime) <= new Date(endTime) : true
        return matchUsername && matchIp && matchStatus && matchStartTime && matchEndTime
      })
      list.sort((a, b) => new Date(b.loginTime).getTime() - new Date(a.loginTime).getTime())
      const pageList = list.filter((item, index) => {
        return index >= ~~from && index < (~~from + ~~limit)
      })
      return {
        error: '',
        status: 1,
        data: {
          list: pageList,
          total: list.length,
        },
      }
    },
  },
  {
    url: '/mock/record/tenant_login_log/detail',
    method: 'get',
    response: ({ query }) => {
      const info = AllList.filter(item => item.id == query.id)
      return {
        error: '',
        status: 1,
        data: info[0] || AllList[0],
      }
    },
  },
])
